import React, { Component } from 'react'
import { Row, Col, Alert} from 'reactstrap'
import { Selector, Nav, Header } from '../NewManageUsers/ManagePane'
import getAccountLicenses from '../../../helpers/users/licenses/getAccountLicenses'
import getPossibleLicenses from '../../../helpers/users/licenses/getPossibleLicenses'
import { BeatLoader } from 'react-spinners'
import { AddLicenses, ManageLicenses } from './'

class SchoolLicenses extends Component {
  state = {
    accountLicenses: null,
    possibleLicenses: null,
    loadingAccountLicenses: false,
    loadingPossibleLicenses: false,
    error: '',
    school: this.props.match.params.id + '',
  }

  componentDidMount() {
    const { school } = this.state
    this.unsubscribe = getAccountLicenses(school, 'school', this.setState.bind(this))
    getPossibleLicenses(this.setState.bind(this))
  }

  componentDidUpdate(prevProps) {
    const school = this.props.match.params.id
    if (school !== prevProps.match.params.id) {
      this.setState({school})
      this.unsubscribe()
      this.unsubscribe = getAccountLicenses(school, 'school', this.setState.bind(this))
      getPossibleLicenses(this.setState.bind(this))
    }
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  render() {
    const { districts, history, user, match, schools,} = this.props
    const { params } = match
    const { accountLicenses, possibleLicenses, error, loadingAccountLicenses, loadingPossibleLicenses } = this.state
    const loading = !!(loadingAccountLicenses || loadingPossibleLicenses || school)
    const school = schools[params.id]
    const district = school && school.district

    

    return (
      <React.Fragment>
         { !loading ? <React.Fragment>
      <Row className='licenses-header'>
     
        <Col>
          <Selector
            districts={districts}
            schools={schools}
            teachers={null}
            id={school && school.id}
            user={user}
            history={history}
            baseLink='/users/licenses/schools/'
            selectorLevel={'school'}
          />
         </Col>
         </Row>
        {!loadingAccountLicenses && !loadingPossibleLicenses && !error &&
      
            <Row className="licenses-body">
              <Col xs='12'>
                <Header className="body-heading">School Licenses</Header>
              </Col>
                      
              <Col xs='12'>
                <h5 className="body-sub-heading">Manage Existing Licenses</h5>
             
                {accountLicenses && accountLicenses.length > 0
                  ? <ManageLicenses 
                      accountLicenses={accountLicenses}
                    />
                  : <p>This account has no licenses yet.</p>
                }
              </Col>
              <Col xs='12'>
                <h5 className="body-sub-heading">Add a New License</h5>
              </Col>
              <Col>
                {possibleLicenses && 
                  <AddLicenses 
                    possibleLicenses={possibleLicenses}
                    district={district}
                    accountId={school && school.id}
                  />
                }
              </Col>
            </Row>
      
        }
        {error && <Alert>{error}</Alert>}
        </React.Fragment>
        
        : <BeatLoader loading={loading} /> }
       
          <Nav back={'/users/licenses/schools'} />
      </React.Fragment>
    )
  }
}

export default SchoolLicenses


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/SchoolLicenses.js